import { Button, TextArea } from '@scale/scaleui';
import React from 'react';
import { StepCard } from 'react-scale/components/scalers/tasks/ThreadedInteraction/step/StepCard';

interface AddCommentBoxProps {
  // commentText state is managed by parent components to persist the text content across re-mounts
  commentText: string;
  setCommentText: (commentText: string) => void;
  submitComment: (commentText: string) => void;
  discardComment: () => void;
  disableAutoFocus?: boolean;
}

const AddCommentBox: React.FC<AddCommentBoxProps> = ({
  commentText,
  setCommentText,
  submitComment,
  discardComment,
  disableAutoFocus = false,
}) => {
  const handleTextAreaInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCommentText(e.target.value);
  };

  const onKeyDownSubmit = (e: React.KeyboardEvent) => {
    if (e.shiftKey && e.key === 'Enter') {
      e.preventDefault();
      submitComment(commentText);
    }
    if (e.key === 'Escape') {
      discardComment();
    }
  };

  return (
    <StepCard className="w-80">
      <StepCard.Header className="px-3 border-b border-neutral-200">
        <StepCard.HeaderLeft>
          <StepCard.Subtitle>Add a comment</StepCard.Subtitle>
        </StepCard.HeaderLeft>
      </StepCard.Header>
      <StepCard.Body className="border-t-0">
        <TextArea
          className="pt-1"
          id="dynamic-textarea"
          rows={1}
          onFocus={(e: React.FocusEvent<HTMLTextAreaElement>) => {
            const textArea = e.target;
            textArea.style.height = 'auto';
            textArea.style.height = textArea.scrollHeight + 'px';
            textArea.style.maxHeight = '16rem';
          }}
          autoFocus={!disableAutoFocus}
          dynamic
          resizable={false}
          onChange={handleTextAreaInputChange}
          value={commentText}
          onKeyDown={onKeyDownSubmit}
        />
      </StepCard.Body>
      <StepCard.Footer className="flex gap-2 justify-end border-t-0">
        <Button onClick={discardComment} size="sm" variant="neutral">
          Cancel
        </Button>
        <Button
          onClick={() => {
            submitComment(commentText);
          }}
          size="sm"
          variant="primary"
        >
          Comment
        </Button>
      </StepCard.Footer>
    </StepCard>
  );
};

export default AddCommentBox;
